// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import AlertBox from "../../Components/AlertBox";
// import { EyeIcon, EyeOffIcon, X, Edit2, Trash2, Plus, Search } from "lucide-react";

// const AddSuperEmployee = () => {
//     // Use local API for development, switch to production for deployment
//     const API_BASE_URL = 'https://greenyellow-nightingale-241896.hostingersite.com/api';
//     // const API_BASE_URL = 'https://greenyellow-nightingale-241896.hostingersite.com/api';

//     const emptyFormData = {
//         teamMemberName: "",
//         mobileNumber: "",
//         email: "",
//         password: "",
//         isActive: true,
//         accessPermissions: []
//     };

//     const [superEmployees, setSuperEmployees] = useState([]);
//     const [formData, setFormData] = useState(emptyFormData);
//     const [loading, setLoading] = useState(true);
//     const [showForm, setShowForm] = useState(false);
//     const [editingId, setEditingId] = useState(null);
//     const [message, setMessage] = useState("");
//     const [showDeleteModal, setShowDeleteModal] = useState(false);
//     const [employeeToDelete, setEmployeeToDelete] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [showPassword, setShowPassword] = useState(false);
//     const [showAlert, setShowAlert] = useState(false);
//     const [validationErrors, setValidationErrors] = useState({
//         mobileNumber: '',
//         email: '',
//         teamMemberName: ''
//     });

//     const [userAccess, setUserAccess] = useState({
//         companies: false,
//         franchises: false,
//         subscription: false,
//         super_employee: false
//     });

//     const [userRole, setUserRole] = useState(null);
//     const [userId, setUserId] = useState(null); // Store logged-in user's ID

//     // Available permissions for SuperEmployees
//     const availablePermissions = [
//         { key: 'companies', label: 'Companies Management' },
//         { key: 'franchises', label: 'Franchises Management' },
//         { key: 'subscription', label: 'Subscription Management' },
//         { key: 'super_employee', label: 'Super Employee Management' }
//     ];

//     // Check user role and permissions
//     useEffect(() => {
//         const token = localStorage.getItem("authToken");
//         if (token) {
//             try {
//                 const decoded = jwtDecode(token);
//                 const role = decoded.role ? decoded.role.toLowerCase() : "";
//                 const id = decoded.id || decoded._id || decoded.userId;

//                 setUserRole(role);
//                 setUserId(id);

//                 console.log('Decoded token:', { role, id, decoded });

//                 if (role === "superadmin" || role === "company") {
//                     const fullAccess = {};
//                     for (const key in userAccess) {
//                         fullAccess[key] = true;
//                     }
//                     setUserAccess(fullAccess);
//                 } else {
//                     const permissionsFromToken = decoded.accessPermissions || [];
//                     const updatedAccess = { ...userAccess };

//                     permissionsFromToken.forEach(permission => {
//                         const permissionKey = permission.toLowerCase();
//                         if (updatedAccess.hasOwnProperty(permissionKey)) {
//                             updatedAccess[permissionKey] = true;
//                         }
//                     });

//                     setUserAccess(updatedAccess);
//                 }
//             } catch (error) {
//                 console.error("Error decoding token:", error);
//             }
//         }
//     }, []);

// // Fetch SuperEmployees - SIMPLIFIED VERSION
// const fetchSuperEmployees = async () => {
//     const token = localStorage.getItem("authToken");
//     if (!token) {
//         setShowAlert("Authentication required. Please log in.");
//         setLoading(false);
//         return;
//     }

//     try {
//         console.log('Fetching super employees for current user');

//         const response = await axios.get(
//             `${API_BASE_URL}/super-employees`,
//             {
//                 headers: { 
//                     Authorization: `Bearer ${token}`,
//                     'Content-Type': 'application/json'
//                 }
//             }
//         );

//         console.log('Fetched super employees response:', response.data);
//         setSuperEmployees(response.data.superEmployees || []);
//         setLoading(false);
//     } catch (err) {
//         console.error("Error fetching super employees:", err);
//         setShowAlert(err.response?.data?.message || "Failed to fetch super employees");
//         setLoading(false);
//     }
// };

// // Call this in useEffect
// useEffect(() => {
//     fetchSuperEmployees();
// }, []);

//     // Validation functions
//     const validateMobileNumber = (number) => {
//         const mobileRegex = /^[0-9]{10}$/;
//         if (!number) return '';
//         if (!mobileRegex.test(number)) {
//             return 'Mobile number must be exactly 10 digits';
//         }
//         return '';
//     };

//     const validateEmail = (email) => {
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!email) return '';
//         if (!emailRegex.test(email)) {
//             return 'Please enter a valid email address';
//         }
//         return '';
//     };

//     const validateTeamMemberName = (name) => {
//         const nameRegex = /^[a-zA-Z\s]+$/;
//         if (!name) return '';
//         if (!nameRegex.test(name)) {
//             return 'Name should only contain letters and spaces';
//         }
//         return '';
//     };

//     // Handle input changes
//     const handleChange = (e) => {
//         const { name, value, type, checked } = e.target;

//         if (type === "checkbox") {
//             setFormData(prev => ({ ...prev, [name]: checked }));
//         } else {
//             setFormData(prev => ({ ...prev, [name]: value }));

//             // Validate on change
//             if (name === 'mobileNumber') {
//                 setValidationErrors(prev => ({
//                     ...prev,
//                     mobileNumber: validateMobileNumber(value)
//                 }));
//             } else if (name === 'email') {
//                 setValidationErrors(prev => ({
//                     ...prev,
//                     email: validateEmail(value)
//                 }));
//             } else if (name === 'teamMemberName') {
//                 setValidationErrors(prev => ({
//                     ...prev,
//                     teamMemberName: validateTeamMemberName(value)
//                 }));
//             }
//         }
//     };

//     // Handle permission checkbox changes
//     const handlePermissionChange = (permission) => {
//         setFormData(prev => {
//             const currentPermissions = prev.accessPermissions || [];
//             const isSelected = currentPermissions.includes(permission);

//             return {
//                 ...prev,
//                 accessPermissions: isSelected
//                     ? currentPermissions.filter(p => p !== permission)
//                     : [...currentPermissions, permission]
//             };
//         });
//     };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validate all fields
//     const mobileError = validateMobileNumber(formData.mobileNumber);
//     const emailError = validateEmail(formData.email);
//     const nameError = validateTeamMemberName(formData.teamMemberName);

//     if (mobileError || emailError || nameError) {
//         setValidationErrors({
//             mobileNumber: mobileError,
//             email: emailError,
//             teamMemberName: nameError
//         });
//         setShowAlert("Please fix validation errors before submitting");
//         return;
//     }

//     const token = localStorage.getItem("authToken");
//     if (!token) {
//         setShowAlert("Authentication required. Please log in.");
//         return;
//     }

//     try {
//         const payload = {
//             teamMemberName: formData.teamMemberName,
//             mobileNumber: formData.mobileNumber,
//             email: formData.email,
//             isActive: formData.isActive,
//             accessPermissions: formData.accessPermissions
//         };

//         // REMOVE THIS PART - Backend will handle it automatically
//         // if (userRole === 'superadmin' && userId) {
//         //     payload.superadmin = userId;
//         // } else if (userRole === 'franchise' && userId) {
//         //     payload.franchise = userId;
//         // }

//         // Only include password if it's provided
//         if (formData.password) {
//             payload.password = formData.password;
//         }

//         if (editingId) {
//             // Update existing super employee
//             await axios.put(
//                 `${API_BASE_URL}/super-employees/${editingId}`,
//                 payload,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Content-Type': 'application/json'
//                     }
//                 }
//             );
//             setMessage("Super Employee updated successfully!");
//         } else {
//             // Create new super employee
//             if (!formData.password) {
//                 setShowAlert("Password is required for new super employees");
//                 return;
//             }

//             await axios.post(
//                 `${API_BASE_URL}/super-employees`,
//                 payload,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Content-Type': 'application/json'
//                     }
//                 }
//             );
//             setMessage("Super Employee created successfully!");
//         }

//         // Reset form and refresh list
//         setFormData(emptyFormData);
//         setEditingId(null);
//         setShowForm(false);
//         fetchSuperEmployees();
//         setShowAlert(message);
//     } catch (err) {
//         console.error("Error saving super employee:", err);
//         setShowAlert(err.response?.data?.message || "Failed to save super employee");
//     }
// };

//     // Edit super employee
//     const handleEdit = (employee) => {
//         setFormData({
//             teamMemberName: employee.teamMemberName,
//             mobileNumber: employee.mobileNumber,
//             email: employee.email,
//             password: "", // Don't populate password for security
//             isActive: employee.isActive,
//             accessPermissions: employee.accessPermissions || []
//         });
//         setEditingId(employee._id);
//         setShowForm(true);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };

//     // Delete super employee
//     const handleDelete = async () => {
//         if (!employeeToDelete) return;

//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             setShowAlert("Authentication required. Please log in.");
//             return;
//         }

//         try {
//             await axios.delete(
//                 `${API_BASE_URL}/super-employees/${employeeToDelete._id}`,
//                 {
//                     headers: { Authorization: `Bearer ${token}` }
//                 }
//             );

//             setMessage("Super Employee deleted successfully!");
//             setShowAlert(message);
//             setShowDeleteModal(false);
//             setEmployeeToDelete(null);
//             fetchSuperEmployees();
//         } catch (err) {
//             console.error("Error deleting super employee:", err);
//             setShowAlert(err.response?.data?.message || "Failed to delete super employee");
//         }
//     };

//     // Toggle active status
//     const toggleStatus = async (employee) => {
//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             setShowAlert("Authentication required. Please log in.");
//             return;
//         }

//         try {
//             await axios.patch(
//                 `${API_BASE_URL}/super-employees/${employee._id}/toggle-status`,
//                 {},
//                 {
//                     headers: { Authorization: `Bearer ${token}` }
//                 }
//             );

//             setMessage(`Super Employee ${!employee.isActive ? 'activated' : 'deactivated'} successfully!`);
//             setShowAlert(message);
//             fetchSuperEmployees();
//         } catch (err) {
//             console.error("Error toggling status:", err);
//             setShowAlert(err.response?.data?.message || "Failed to toggle status");
//         }
//     };

//     // Cancel form
//     const handleCancel = () => {
//         setFormData(emptyFormData);
//         setEditingId(null);
//         setShowForm(false);
//         setValidationErrors({
//             mobileNumber: '',
//             email: '',
//             teamMemberName: ''
//         });
//     };

//     // Filter super employees based on search
//     const filteredEmployees = superEmployees.filter(emp =>
//         emp.teamMemberName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         emp.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         emp.mobileNumber.includes(searchTerm)
//     );

//     if (loading || !userId) {
//         return (
//             <div className="flex justify-center items-center h-screen">
//                 <div className="text-xl">Loading...</div>
//             </div>
//         );
//     }

//     return (
//         <div className="container mx-auto p-6">
//             {showAlert && (
//                 <AlertBox
//                     message={showAlert}
//                     onClose={() => setShowAlert(false)}
//                 />
//             )}

//             {/* Add/Edit Form */}
//             {showForm && (
//                 <div className="bg-white rounded-lg shadow-md p-6 mb-6">
//                     <h2 className="text-2xl font-semibold mb-4">
//                         {editingId ? "Edit Super Employee" : "Add New Super Employee"}
//                     </h2>

//                     <form onSubmit={handleSubmit}>
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                             {/* Team Member Name */}
//                             <div>
//                                 <label className="block text-sm font-medium mb-1">
//                                     Team Member Name <span className="text-red-500">*</span>
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="teamMemberName"
//                                     value={formData.teamMemberName}
//                                     onChange={handleChange}
//                                     className={`w-full px-3 py-2 border rounded-md ${validationErrors.teamMemberName ? 'border-red-500' : 'border-gray-300'
//                                         }`}
//                                     required
//                                 />
//                                 {validationErrors.teamMemberName && (
//                                     <p className="text-red-500 text-xs mt-1">{validationErrors.teamMemberName}</p>
//                                 )}
//                             </div>

//                             {/* Mobile Number */}
//                             <div>
//                                 <label className="block text-sm font-medium mb-1">
//                                     Mobile Number <span className="text-red-500">*</span>
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="mobileNumber"
//                                     value={formData.mobileNumber}
//                                     onChange={handleChange}
//                                     className={`w-full px-3 py-2 border rounded-md ${validationErrors.mobileNumber ? 'border-red-500' : 'border-gray-300'
//                                         }`}
//                                     required
//                                     maxLength="10"
//                                 />
//                                 {validationErrors.mobileNumber && (
//                                     <p className="text-red-500 text-xs mt-1">{validationErrors.mobileNumber}</p>
//                                 )}
//                             </div>

//                             {/* Email */}
//                             <div>
//                                 <label className="block text-sm font-medium mb-1">
//                                     Email <span className="text-red-500">*</span>
//                                 </label>
//                                 <input
//                                     type="email"
//                                     name="email"
//                                     value={formData.email}
//                                     onChange={handleChange}
//                                     className={`w-full px-3 py-2 border rounded-md ${validationErrors.email ? 'border-red-500' : 'border-gray-300'
//                                         }`}
//                                     required
//                                 />
//                                 {validationErrors.email && (
//                                     <p className="text-red-500 text-xs mt-1">{validationErrors.email}</p>
//                                 )}
//                             </div>

//                             {/* Password */}
//                             <div>
//                                 <label className="block text-sm font-medium mb-1">
//                                     Password {!editingId && <span className="text-red-500">*</span>}
//                                     {editingId && <span className="text-gray-500 text-xs">(Leave blank to keep current)</span>}
//                                 </label>
//                                 <div className="relative">
//                                     <input
//                                         type={showPassword ? "text" : "password"}
//                                         name="password"
//                                         value={formData.password}
//                                         onChange={handleChange}
//                                         className="w-full px-3 py-2 border border-gray-300 rounded-md pr-10"
//                                         required={!editingId}
//                                     />
//                                     <button
//                                         type="button"
//                                         onClick={() => setShowPassword(!showPassword)}
//                                         className="absolute right-2 top-1/2 transform -translate-y-1/2"
//                                     >
//                                         {showPassword ? <EyeOffIcon size={20} /> : <EyeIcon size={20} />}
//                                     </button>
//                                 </div>
//                             </div>

//                             {/* Active Status */}
//                             <div className="flex items-center">
//                                 <label className="flex items-center cursor-pointer">
//                                     <input
//                                         type="checkbox"
//                                         name="isActive"
//                                         checked={formData.isActive}
//                                         onChange={handleChange}
//                                         className="mr-2 h-4 w-4"
//                                     />
//                                     <span className="text-sm font-medium">Active</span>
//                                 </label>
//                             </div>
//                         </div>

//                         {/* Access Permissions */}
//                         <div className="mt-6">
//                             <h3 className="text-lg font-semibold mb-3">Access Permissions</h3>
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                                 {availablePermissions.map(permission => (
//                                     <label key={permission.key} className="flex items-center cursor-pointer p-3 border rounded-md hover:bg-gray-50">
//                                         <input
//                                             type="checkbox"
//                                             checked={formData.accessPermissions.includes(permission.key)}
//                                             onChange={() => handlePermissionChange(permission.key)}
//                                             className="mr-3 h-4 w-4"
//                                         />
//                                         <span className="text-sm">{permission.label}</span>
//                                     </label>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* Form Actions */}
//                         <div className="flex gap-3 mt-6">
//                             <button
//                                 type="submit"
//                                 className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//                             >
//                                 {editingId ? "Update" : "Create"} Super Employee
//                             </button>
//                             <button
//                                 type="button"
//                                 onClick={handleCancel}
//                                 className="px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
//                             >
//                                 Cancel
//                             </button>
//                         </div>
//                     </form>
//                 </div>
//             )}

//             {/* List View */}
//             {!showForm && (
//                 <div className="bg-white rounded-lg shadow-md p-6">
//                     <div className="flex justify-between items-center mb-4">
//                         <h2 className="text-2xl font-semibold">Super Employees List</h2>
//                         <button
//                             onClick={() => setShowForm(true)}
//                             className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
//                         >
//                             <Plus size={20} />
//                             Add New
//                         </button>
//                     </div>

//                     {/* Search */}
//                     <div className="mb-4">
//                         <div className="relative">
//                             <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
//                             <input
//                                 type="text"
//                                 placeholder="Search by name, email, or mobile..."
//                                 value={searchTerm}
//                                 onChange={(e) => setSearchTerm(e.target.value)}
//                                 className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md"
//                             />
//                         </div>
//                     </div>

//                     {/* Table */}
//                     <div className="overflow-x-auto">
//                         <table className="w-full">
//                             <thead className="bg-gray-100">
//                                 <tr>
//                                     <th className="px-4 py-3 text-left text-sm font-semibold">Name</th>
//                                     <th className="px-4 py-3 text-left text-sm font-semibold">Email</th>
//                                     <th className="px-4 py-3 text-left text-sm font-semibold">Mobile</th>
//                                     <th className="px-4 py-3 text-left text-sm font-semibold">Status</th>
//                                     <th className="px-4 py-3 text-left text-sm font-semibold">Permissions</th>
//                                     <th className="px-4 py-3 text-left text-sm font-semibold">Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {filteredEmployees.length === 0 ? (
//                                     <tr>
//                                         <td colSpan="6" className="px-4 py-8 text-center text-gray-500">
//                                             No super employees found
//                                         </td>
//                                     </tr>
//                                 ) : (
//                                     filteredEmployees.map(employee => (
//                                         <tr key={employee._id} className="border-b hover:bg-gray-50">
//                                             <td className="px-4 py-3">{employee.teamMemberName}</td>
//                                             <td className="px-4 py-3">{employee.email}</td>
//                                             <td className="px-4 py-3">{employee.mobileNumber}</td>
//                                             <td className="px-4 py-3">
//                                                 <button
//                                                     onClick={() => toggleStatus(employee)}
//                                                     className={`px-3 py-1 rounded-full text-xs font-semibold ${employee.isActive
//                                                         ? 'bg-green-100 text-green-800'
//                                                         : 'bg-red-100 text-red-800'
//                                                         }`}
//                                                 >
//                                                     {employee.isActive ? 'Active' : 'Inactive'}
//                                                 </button>
//                                             </td>
//                                             <td className="px-4 py-3">
//                                                 <div className="flex flex-wrap gap-1">
//                                                     {employee.accessPermissions && employee.accessPermissions.length > 0 ? (
//                                                         employee.accessPermissions.map(perm => (
//                                                             <span key={perm} className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
//                                                                 {perm}
//                                                             </span>
//                                                         ))
//                                                     ) : (
//                                                         <span className="text-gray-400 text-xs">No permissions</span>
//                                                     )}
//                                                 </div>
//                                             </td>
//                                             <td className="px-4 py-3">
//                                                 <div className="flex gap-2">
//                                                     <button
//                                                         onClick={() => handleEdit(employee)}
//                                                         className="p-2 text-blue-600 hover:bg-blue-50 rounded"
//                                                         title="Edit"
//                                                     >
//                                                         <Edit2 size={18} />
//                                                     </button>
//                                                     <button
//                                                         onClick={() => {
//                                                             setEmployeeToDelete(employee);
//                                                             setShowDeleteModal(true);
//                                                         }}
//                                                         className="p-2 text-red-600 hover:bg-red-50 rounded"
//                                                         title="Delete"
//                                                     >
//                                                         <Trash2 size={18} />
//                                                     </button>
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     ))
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             )}

//             {/* Delete Confirmation Modal */}
//             {showDeleteModal && (
//                 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//                     <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
//                         <h3 className="text-xl font-semibold mb-4">Confirm Delete</h3>
//                         <p className="mb-6">
//                             Are you sure you want to delete <strong>{employeeToDelete?.teamMemberName}</strong>?
//                             This action cannot be undone.
//                         </p>
//                         <div className="flex gap-3 justify-end">
//                             <button
//                                 onClick={() => {
//                                     setShowDeleteModal(false);
//                                     setEmployeeToDelete(null);
//                                 }}
//                                 className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={handleDelete}
//                                 className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
//                             >
//                                 Delete
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default AddSuperEmployee;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import AlertBox from "../../Components/AlertBox";
import { EyeIcon, EyeOffIcon, X, Edit2, Trash2, Plus, Search } from "lucide-react";

const AddSuperEmployee = () => {
    // Use local API for development, switch to production for deployment
    const API_BASE_URL = 'https://greenyellow-nightingale-241896.hostingersite.com/api';
    // const API_BASE_URL = 'https://greenyellow-nightingale-241896.hostingersite.com/api';

    const emptyFormData = {
        teamMemberName: "",
        mobileNumber: "",
        email: "",
        password: "",
        isActive: true,
        accessPermissions: []
    };

    const [superEmployees, setSuperEmployees] = useState([]);
    const [formData, setFormData] = useState(emptyFormData);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [message, setMessage] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [employeeToDelete, setEmployeeToDelete] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [validationErrors, setValidationErrors] = useState({
        mobileNumber: '',
        email: '',
        teamMemberName: ''
    });

    const [userAccess, setUserAccess] = useState({
        companies: false,
        franchises: false,
        subscription: false,
        super_employee: false
    });

    const [userRole, setUserRole] = useState(null);
    const [userId, setUserId] = useState(null); // Store logged-in user's ID

    // Available permissions for SuperEmployees
    const availablePermissions = [
        { key: 'companies', label: 'Companies Management' },
        { key: 'franchises', label: 'Franchises Management' },
        { key: 'subscription', label: 'Subscription Management' },
        { key: 'super_employee', label: 'Super Employee Management' }
    ];

    // Check user role and permissions
    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                const role = decoded.role ? decoded.role.toLowerCase() : "";
                const id = decoded.id || decoded._id || decoded.userId;

                setUserRole(role);
                setUserId(id);

                console.log('Decoded token:', { role, id, decoded });

                if (role === "superadmin" || role === "company") {
                    const fullAccess = {};
                    for (const key in userAccess) {
                        fullAccess[key] = true;
                    }
                    setUserAccess(fullAccess);
                } else {
                    const permissionsFromToken = decoded.accessPermissions || [];
                    const updatedAccess = { ...userAccess };

                    permissionsFromToken.forEach(permission => {
                        const permissionKey = permission.toLowerCase();
                        if (updatedAccess.hasOwnProperty(permissionKey)) {
                            updatedAccess[permissionKey] = true;
                        }
                    });

                    setUserAccess(updatedAccess);
                }
            } catch (error) {
                console.error("Error decoding token:", error);
            }
        }
    }, []);

    // Fetch SuperEmployees - SIMPLIFIED VERSION
    const fetchSuperEmployees = async () => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            setShowAlert("Authentication required. Please log in.");
            setLoading(false);
            return;
        }

        try {
            console.log('Fetching super employees for current user');

            const response = await axios.get(
                `${API_BASE_URL}/super-employees`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            console.log('Fetched super employees response:', response.data);
            setSuperEmployees(response.data.superEmployees || []);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching super employees:", err);
            setShowAlert(err.response?.data?.message || "Failed to fetch super employees");
            setLoading(false);
        }
    };

    // Call this in useEffect
    useEffect(() => {
        fetchSuperEmployees();
    }, []);

    // Validation functions
    const validateMobileNumber = (number) => {
        const mobileRegex = /^[0-9]{10}$/;
        if (!number) return '';
        if (!mobileRegex.test(number)) {
            return 'Mobile number must be exactly 10 digits';
        }
        return '';
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) return '';
        if (!emailRegex.test(email)) {
            return 'Please enter a valid email address';
        }
        return '';
    };

    const validateTeamMemberName = (name) => {
        const nameRegex = /^[a-zA-Z\s]+$/;
        if (!name) return '';
        if (!nameRegex.test(name)) {
            return 'Name should only contain letters and spaces';
        }
        return '';
    };

    // Handle input changes
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === "checkbox") {
            setFormData(prev => ({ ...prev, [name]: checked }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));

            // Validate on change
            if (name === 'mobileNumber') {
                setValidationErrors(prev => ({
                    ...prev,
                    mobileNumber: validateMobileNumber(value)
                }));
            } else if (name === 'email') {
                setValidationErrors(prev => ({
                    ...prev,
                    email: validateEmail(value)
                }));
            } else if (name === 'teamMemberName') {
                setValidationErrors(prev => ({
                    ...prev,
                    teamMemberName: validateTeamMemberName(value)
                }));
            }
        }
    };

    // Handle permission checkbox changes
    const handlePermissionChange = (permission) => {
        setFormData(prev => {
            const currentPermissions = prev.accessPermissions || [];
            const isSelected = currentPermissions.includes(permission);

            return {
                ...prev,
                accessPermissions: isSelected
                    ? currentPermissions.filter(p => p !== permission)
                    : [...currentPermissions, permission]
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate all fields
        const mobileError = validateMobileNumber(formData.mobileNumber);
        const emailError = validateEmail(formData.email);
        const nameError = validateTeamMemberName(formData.teamMemberName);

        if (mobileError || emailError || nameError) {
            setValidationErrors({
                mobileNumber: mobileError,
                email: emailError,
                teamMemberName: nameError
            });
            setShowAlert("Please fix validation errors before submitting");
            return;
        }

        const token = localStorage.getItem("authToken");
        if (!token) {
            setShowAlert("Authentication required. Please log in.");
            return;
        }

        try {
            const payload = {
                teamMemberName: formData.teamMemberName,
                mobileNumber: formData.mobileNumber,
                email: formData.email,
                isActive: formData.isActive,
                accessPermissions: formData.accessPermissions
            };

            // REMOVE THIS PART - Backend will handle it automatically
            // if (userRole === 'superadmin' && userId) {
            //     payload.superadmin = userId;
            // } else if (userRole === 'franchise' && userId) {
            //     payload.franchise = userId;
            // }

            // Only include password if it's provided
            if (formData.password) {
                payload.password = formData.password;
            }

            if (editingId) {
                // Update existing super employee
                await axios.put(
                    `${API_BASE_URL}/super-employees/${editingId}`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );
                setShowAlert("Super Employee updated successfully!");
            } else {
                // Create new super employee
                if (!formData.password) {
                    setShowAlert("Password is required for new super employees");
                    return;
                }

                await axios.post(
                    `${API_BASE_URL}/super-employees`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );
                setShowAlert("Super Employee created successfully!");
            }

            // Reset form and refresh list
            setFormData(emptyFormData);
            setEditingId(null);
            setShowForm(false);
            fetchSuperEmployees();
        } catch (err) {
            console.error("Error saving super employee:", err);
            setShowAlert(err.response?.data?.message || "Failed to save super employee");
        }
    };

    // Edit super employee
    const handleEdit = (employee) => {
        setFormData({
            teamMemberName: employee.teamMemberName,
            mobileNumber: employee.mobileNumber,
            email: employee.email,
            password: "", // Don't populate password for security
            isActive: employee.isActive,
            accessPermissions: employee.accessPermissions || []
        });
        setEditingId(employee._id);
        setShowForm(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Delete super employee
    const handleDelete = async () => {
        if (!employeeToDelete) return;

        const token = localStorage.getItem("authToken");
        if (!token) {
            setShowAlert("Authentication required. Please log in.");
            return;
        }

        try {
            await axios.delete(
                `${API_BASE_URL}/super-employees/${employeeToDelete._id}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            setShowAlert("Super Employee deleted successfully!");
            setShowDeleteModal(false);
            setEmployeeToDelete(null);
            fetchSuperEmployees();
        } catch (err) {
            console.error("Error deleting super employee:", err);
            setShowAlert(err.response?.data?.message || "Failed to delete super employee");
        }
    };

    // Toggle active status
    const toggleStatus = async (employee) => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            setShowAlert("Authentication required. Please log in.");
            return;
        }

        try {
            await axios.patch(
                `${API_BASE_URL}/super-employees/${employee._id}/toggle-status`,
                {},
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            setShowAlert(`Super Employee ${!employee.isActive ? 'activated' : 'deactivated'} successfully!`);
            fetchSuperEmployees();
        } catch (err) {
            console.error("Error toggling status:", err);
            setShowAlert(err.response?.data?.message || "Failed to toggle status");
        }
    };

    // Cancel form
    const handleCancel = () => {
        setFormData(emptyFormData);
        setEditingId(null);
        setShowForm(false);
        setValidationErrors({
            mobileNumber: '',
            email: '',
            teamMemberName: ''
        });
    };

    // Filter super employees based on search
    const filteredEmployees = superEmployees.filter(emp =>
        emp.teamMemberName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        emp.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        emp.mobileNumber.includes(searchTerm)
    );

    if (loading || !userId) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="text-xl">Loading...</div>
            </div>
        );
    }

    return (
        <div className="container mx-auto p-6">
            {showAlert && (
                <AlertBox
                    message={showAlert}
                    onClose={() => setShowAlert(false)}
                />
            )}

            {/* Add/Edit Form */}
            {showForm && (
                <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                    <h2 className="text-2xl font-semibold mb-4">
                        {editingId ? "Edit Super Employee" : "Add New Super Employee"}
                    </h2>

                    <form onSubmit={handleSubmit}>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {/* Team Member Name */}
                            <div>
                                <label className="block text-sm font-medium mb-1">
                                    Team Member Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="teamMemberName"
                                    value={formData.teamMemberName}
                                    onChange={handleChange}
                                    placeholder="Enter team member name"
                                    className={`w-full px-3 py-2 border rounded-md ${validationErrors.teamMemberName ? 'border-red-500' : 'border-gray-300'
                                        }`}
                                    required
                                />
                                {validationErrors.teamMemberName && (
                                    <p className="text-red-500 text-xs mt-1">{validationErrors.teamMemberName}</p>
                                )}
                            </div>

                            {/* Mobile Number */}
                            <div>
                                <label className="block text-sm font-medium mb-1">
                                    Mobile Number <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="mobileNumber"
                                    value={formData.mobileNumber}
                                    onChange={handleChange}
                                    placeholder="Enter 10-digit mobile number"
                                    className={`w-full px-3 py-2 border rounded-md ${validationErrors.mobileNumber ? 'border-red-500' : 'border-gray-300'
                                        }`}
                                    required
                                    maxLength="10"
                                />
                                {validationErrors.mobileNumber && (
                                    <p className="text-red-500 text-xs mt-1">{validationErrors.mobileNumber}</p>
                                )}
                            </div>

                            {/* Email */}
                            <div>
                                <label className="block text-sm font-medium mb-1">
                                    Email <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Enter email address"
                                    className={`w-full px-3 py-2 border rounded-md ${validationErrors.email ? 'border-red-500' : 'border-gray-300'
                                        }`}
                                    required
                                />
                                {validationErrors.email && (
                                    <p className="text-red-500 text-xs mt-1">{validationErrors.email}</p>
                                )}
                            </div>

                            {/* Password */}
                            <div>
                                <label className="block text-sm font-medium mb-1">
                                    Password {!editingId && <span className="text-red-500">*</span>}
                                    {editingId && <span className="text-gray-500 text-xs">(Leave blank to keep current)</span>}
                                </label>
                                <div className="relative">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        placeholder={editingId ? "Leave blank to keep current password" : "Enter password"}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md pr-10"
                                        required={!editingId}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="absolute right-2 top-1/2 transform -translate-y-1/2"
                                    >
                                        {showPassword ? <EyeOffIcon size={20} /> : <EyeIcon size={20} />}
                                    </button>
                                </div>
                            </div>

                            {/* Active Status */}
                            <div className="flex items-center">
                                <label className="flex items-center cursor-pointer">
                                    <input
                                        type="checkbox"
                                        name="isActive"
                                        checked={formData.isActive}
                                        onChange={handleChange}
                                        className="mr-2 h-4 w-4"
                                    />
                                    <span className="text-sm font-medium">Active</span>
                                </label>
                            </div>
                        </div>

                        {/* Access Permissions */}
                        <div className="mt-6">
                            <h3 className="text-lg font-semibold mb-3">Access Permissions</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                {availablePermissions.map(permission => (
                                    <label key={permission.key} className="flex items-center cursor-pointer p-3 border rounded-md hover:bg-gray-50">
                                        <input
                                            type="checkbox"
                                            checked={formData.accessPermissions.includes(permission.key)}
                                            onChange={() => handlePermissionChange(permission.key)}
                                            className="mr-3 h-4 w-4"
                                        />
                                        <span className="text-sm">{permission.label}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* Form Actions */}
                        <div className="flex gap-3 mt-6">
                            <button
                                type="submit"
                                className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                            >
                                {editingId ? "Update" : "Create"} Super Employee
                            </button>
                            <button
                                type="button"
                                onClick={handleCancel}
                                className="px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            )}

            {/* List View */}
            {!showForm && (
                <div className="bg-white rounded-lg shadow-md p-6">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-2xl font-semibold">Super Employees List</h2>
                        <button
                            onClick={() => setShowForm(true)}
                            className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
                        >
                            <Plus size={20} />
                            Add New
                        </button>
                    </div>

                    {/* Search */}
                    <div className="mb-4">
                        <div className="relative">
                            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                            <input
                                type="text"
                                placeholder="Search by name, email, or mobile..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md"
                            />
                        </div>
                    </div>

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Name</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Email</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Mobile</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Status</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Permissions</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredEmployees.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" className="px-4 py-8 text-center text-gray-500">
                                            No super employees found
                                        </td>
                                    </tr>
                                ) : (
                                    filteredEmployees.map(employee => (
                                        <tr key={employee._id} className="border-b hover:bg-gray-50">
                                            <td className="px-4 py-3">{employee.teamMemberName}</td>
                                            <td className="px-4 py-3">{employee.email}</td>
                                            <td className="px-4 py-3">{employee.mobileNumber}</td>
                                            <td className="px-4 py-3">
                                                <button
                                                    onClick={() => toggleStatus(employee)}
                                                    className={`px-3 py-1 rounded-full text-xs font-semibold ${employee.isActive
                                                        ? 'bg-green-100 text-green-800'
                                                        : 'bg-red-100 text-red-800'
                                                        }`}
                                                >
                                                    {employee.isActive ? 'Active' : 'Inactive'}
                                                </button>
                                            </td>
                                            <td className="px-4 py-3">
                                                <div className="flex flex-wrap gap-1">
                                                    {employee.accessPermissions && employee.accessPermissions.length > 0 ? (
                                                        employee.accessPermissions.map(perm => (
                                                            <span key={perm} className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
                                                                {perm}
                                                            </span>
                                                        ))
                                                    ) : (
                                                        <span className="text-gray-400 text-xs">No permissions</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="px-4 py-3">
                                                <div className="flex gap-2">
                                                    <button
                                                        onClick={() => handleEdit(employee)}
                                                        className="p-2 text-blue-600 hover:bg-blue-50 rounded"
                                                        title="Edit"
                                                    >
                                                        <Edit2 size={18} />
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            setEmployeeToDelete(employee);
                                                            setShowDeleteModal(true);
                                                        }}
                                                        className="p-2 text-red-600 hover:bg-red-50 rounded"
                                                        title="Delete"
                                                    >
                                                        <Trash2 size={18} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
                        <h3 className="text-xl font-semibold mb-4">Confirm Delete</h3>
                        <p className="mb-6">
                            Are you sure you want to delete <strong>{employeeToDelete?.teamMemberName}</strong>?
                            This action cannot be undone.
                        </p>
                        <div className="flex gap-3 justify-end">
                            <button
                                onClick={() => {
                                    setShowDeleteModal(false);
                                    setEmployeeToDelete(null);
                                }}
                                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddSuperEmployee;


